/** Payment domain constants. Previously in shared/constants/payment-constants.js */
export const URLS = {
    TERMS_AND_CONDITIONS: 'https://www.informa.com/generic-content/terms--conditions/',
    PRIVACY_POLICY: 'https://privacy.informa.com/policies/en/',
};

export const PAYMENT_TEXTS = {
  CARD: {
    TITLE: 'Credit or debit card',
    SUBTITLE_DESKTOP: 'pay with your card',
    SUBTITLE_MOBILE: 'pay with your Visa, Mastercard, or American Express',
    NAME_PLACEHOLDER: 'S Smith',
    TEMP_HOLD_MESSAGE:
      "A temporary hold will apply; you won't be charged until your order is approved.",
    CVV_TOOLTIP:
      'The CVV (Card Verification Value) is a 3-digit number found on the back of Visa, Mastercard, and Discover cards, or a 4-digit number on the front of American Express cards. It helps verify that you have physical access to the card and adds a layer of fraud protection.',
  },
  INVOICE: {
    TITLE: 'Pay via Invoice',
    SUBTITLE: 'buy now, pay later',
    EMAIL_LABEL: 'Recipient email:',
    EMAIL_PLACEHOLDER: 'Enter recepient email',
    EMAIL_REGEX:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    INSTRUCTIONS:
      'An invoice will be generated and sent to the email above. Please follow the instructions in the invoice to complete your payment. Your order will remain pending until payment is received and confirmed.',
    WARNING:
      'Failure to pay by the due date may result in your order being cancelled and/or additional fees incurred.',
  },
  TERMS: {
    HEADING: 'Terms & Conditions',
    AGREEMENT_PRE: 'I agree to the ',
    TERMS_LINK: 'Terms and Conditions',
    AND: ' and the ',
    PRIVACY_LINK: 'Privacy Policy',
    COMMA_AND: ', and ',
    EVENT_PRIVACY_LINK: 'Event Privacy Notice',
    TOOLTIP:
      'By agreeing to these terms, you confirm that you have read and accept our Terms and Conditions, Privacy Policy, and Event Privacy Notice.',
  },
  SPONSORS: {
    HEADING: 'Sponsors and Exhibitors',
    TEXT: 'I would like to receive information about the latest innovations, products and services from the ',
    LINK_TEXT: 'exhibitors and sponsors',
    TEXT_POST:
      ' of this event. You can opt out of receiving these messages at any time by clicking unsubscribe or contacting the sender.',
  },
  MARKETING: {
    EMAIL: 'Email',
    PHONE: 'Phone',
    SMS: 'SMS',
  },
};

export const INVOICE_FALLBACK_DECLINE_CODES: string[] = [
  'generic_decline',
  'insufficient_funds',
  'lost_card',
  'stolen_card',
  'card_velocity_exceeded',
];

export const INVOICE_FALLBACK_ERROR_CODES: string[] = [
  'card_declined',
  'expired_card',
  'incorrect_cvc',
  'processing_error',
  'incorrect_number',
];

export const PAYMENT_METHODS = {
    CARD_AND_INVOICE: 'cardAndInvoice',
} as const;
